import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from '@ibe/types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../lib/cn.js';
import { Button } from './button.js';
/**
 * Page navigation for a list.
 *
 * Driven entirely by the API's own `PaginationMeta` rather than by a count the
 * client derives. `hasNextPage` is the server's answer, and re-deriving it
 * from `page < totalPages` means a filtered query whose total the server
 * computes differently produces a next button that leads to an empty page.
 *
 * The range summary is not decoration. "Showing 21–40 of 312" is how someone
 * confirms a filter did what they expected, and its absence is why people
 * scroll a list twice.
 */
export function Pagination({ meta, onPageChange, disabled = false, className, itemNoun = { one: 'item', many: 'items' }, }) {
    const first = meta.totalItems === 0 ? 0 : (meta.page - 1) * meta.pageSize + 1;
    const last = Math.min(meta.page * meta.pageSize, meta.totalItems);
    const noun = meta.totalItems === 1 ? itemNoun.one : itemNoun.many;
    return (_jsxs("nav", { "aria-label": "Pagination", className: cn('flex items-center justify-between gap-4 py-3', className), children: [_jsx("p", { "aria-live": "polite", className: "text-sm text-muted-foreground", children: meta.totalItems === 0
                    ? `No ${itemNoun.many}`
                    : `Showing ${String(first)}–${String(last)} of ${String(meta.totalItems)} ${noun}` }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Button, { variant: "outline", size: "icon", className: "h-8 w-8", disabled: disabled || !meta.hasPreviousPage, onClick: () => {
                            onPageChange(meta.page - 1);
                        }, "aria-label": "Previous page", children: _jsx(ChevronLeft, { className: "h-4 w-4", "aria-hidden": "true" }) }), _jsx("span", { "aria-current": "page", className: "flex h-8 min-w-[2rem] items-center justify-center rounded-md bg-primary px-2 text-sm font-medium text-primary-foreground", children: meta.page }), _jsx(Button, { variant: "outline", size: "icon", className: "h-8 w-8", disabled: disabled || !meta.hasNextPage, onClick: () => {
                            onPageChange(meta.page + 1);
                        }, "aria-label": "Next page", children: _jsx(ChevronRight, { className: "h-4 w-4", "aria-hidden": "true" }) })] })] }));
}
//# sourceMappingURL=pagination.js.map